export default {
  LOAD_COMPETENCY_SURVEY_FORM_PAGE_START: 'LoadCompetencySurveyFormPageStart',
  LOAD_COMPETENCY_SURVEY_FORM_PAGE_END: 'LoadCompetencySurveyFormPageEnd',
  LOAD_COMPETENCY_SURVEY_AVAILABLE_COMPETENCIES_START: 'LoadCompetencySurveyAvailableCompetenciesStart',
  LOAD_COMPETENCY_SURVEY_AVAILABLE_COMPETENCIES_END: 'LoadCompetencySurveyAvailableCompetenciesEnd',
  LOAD_COMPETENCY_SURVEY_AVAILABLE_STUDY_PROGRAMS_START: 'LoadCompetencySurveyAvailableStudyProgramsStart',
  LOAD_COMPETENCY_SURVEY_AVAILABLE_STUDY_PROGRAMS_END: 'LoadCompetencySurveyAvailableStudyProgramsEnd',
  COMPETENCY_SURVEY_SELECT_STUDY_PROGRAM: 'CompetencySurveySelectSTudyProgram'
};